import React from 'react';
import DatePicker from 'react-datepicker';

const DatepickerFormGroup = ({label, isRequired, name, value, onChange}) => {
    return (
        <div className="form-group">
            <label htmlFor={name} className="control-label col-md-4">
                {label}{isRequired ? '*' : ''}
            </label>
            <div className="col-md-8">
                <DatePicker className="form-control"
                            name={name}
                            id={name}
                            selected={value}
                            onChange={onChange}
                            dateFormat="DD/MM/YYYY"
                            locale="el"
                            dropdownMode="select"/>
            </div>
        </div>
    );
}

export default DatepickerFormGroup;